import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import React from "react";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Heart from "../../Assets/Images/HEART.png";
import Soul from "../../Assets/Images/SOUL.png";
import Mind from "../../Assets/Images/MIND.png";
import Strength from "../../Assets/Images/STRENGTH.png";
import Header from "../GeneratePdf/Header";
import Footer from "../GeneratePdf/Footer";

// Font Register
Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

// Styles
const styles = StyleSheet.create({
  page: { flexDirection: "column", paddingHorizontal: 20, paddingVertical: 10, fontFamily: "Lato", paddingBottom: 0, },
  content: { flexGrow: 1, },
  footer: { marginTop: "auto", },
  headerBox: { display: "flex", marginBottom: 5, },
  title: { fontSize: 18, fontWeight: 700, color: "#426B88", },
  subTitle: { fontSize: 12, color: "#245775", marginTop: "5px", fontWeight: 400, },
  table: { width: "100%", borderWidth: 1, borderColor: "#ccc", },
  tableRow: { flexDirection: "row", borderBottomWidth: 1, borderBottomColor: "#ccc", paddingVertical: 5, alignItems: "center", borderLeftWidth: 1, borderLeftColor: "#ccc", borderRightWidth: 1, borderRightColor: "#ccc", },
  tableHeader: { fontWeight: 400, border: "0px", backgroundColor: "#426B88", fontWeight: "bold", color: "white", borderTopLeftRadius: 4, borderTopRightRadius: 4, marginTop: 30, overflow: "hidden", paddingVertical: 8, },
  container: { marginTop: "10px", marginLeft: "10px", width: "500px", height: "26px", flexDirection: "row", justifyContent: "space-evenly", alignItems: "center", backgroundColor: "#EAF1F5", },
  text: { color: "#00577D", fontWeight: "700", fontFamily: "Lato", fontSize: "12px", },
  headerCell: { color: "white", fontWeight: 400 },
  cellIndex: { width: "5%", textAlign: "center", fontSize: 10, color: "#394554", },
  cellQuadrant: { width: "17%", textAlign: "left", fontSize: 10, color: "#394554", },
  cellLogo: { width: "5%", textAlign: "center" },
  cellQuestion: { width: "38%", fontSize: 10, paddingHorizontal: 4, color: "#394554", fontWeight: 400, },
  cellScore: { width: "7%", textAlign: "center", fontSize: 10, color: "#394554", },
  cell: { flex: 1, fontSize: 10, paddingHorizontal: 4, },
  logo: { width: 14.3, height: 14.3, },
});
// Dummy Data Array
const dummyData = [
  {
    quadrant: "STRENGTH",
    question: "I come alive when you feel like I belong.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] wants to feel connected to others while doing something.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] finds satisfaction in developing standardized procedures.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "When working on a project, [First Name] can become too emotionally invested.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "When working on a project, [First Name] can get stuck by overthinking everything.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] can lose momentum without clear, measurable goals.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] struggles to stay engaged when the work has no clear purpose.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] is drawn to people who are visionaries.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name]'s strong feelings sometimes overwhelm good judgment.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] believes the right structures are essential for an effective organization.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] likes turning good ideas into action.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] takes satisfaction in a hard day's work.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] finds satisfaction in developing effective systems.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] finds satisfaction in sharing meaningful stories that impact people’s lives.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: '[First Name] finds satisfaction in feeling connected to the people they work with.',
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
];



// Truncate Text Function
const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

// Quadrant Logo Function
const getQuadrantLogo = () => <Image src={Heart} style={styles.logo} />;

const QuadrantFlowItemThird360 = ({apiData}) => {
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  return (
    <View style={styles.page}>
      {/* <Header /> */}

      <View>
        <Text style={styles.title}>QUADRANT FLOW 360 ITEMS OVERVIEW</Text>
      </View>

      <View>
        {/* Table Header */}
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.cellIndex, styles.headerCell]}>#</Text>
          <Text style={[styles.cellQuadrant, styles.headerCell]}>Quadrant</Text>
          <Text style={[styles.cellLogo, styles.headerCell]}></Text>
          <Text style={[styles.cellQuestion, styles.headerCell]}>Question</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>S</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>M1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>D1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>P1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>P2</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>P3</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>O1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>O2</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>A</Text>
        </View>

        {/* Table Rows */}
        {dummyData.length > 0 ? (
          dummyData.map((item, index) => (
            <View key={index} style={[ styles.tableRow, { backgroundColor: index % 2 === 0 ? "#F1F3F3" : "#FFF" }, ]} >
              <Text style={styles.cellIndex}>{index + 27}</Text>
              <Text style={styles.cellQuadrant}>{item.quadrant}</Text>
              <View style={styles.cellLogo}> {getQuadrantLogo(item.quadrant)} </View>
              <Text style={styles.cellQuestion}> {item.question.replace(/\[First Name\]/g, respondentName)} </Text>
              <Text style={styles.cellScore}>{item.s}</Text>
              <Text style={styles.cellScore}>{item.m1}</Text>
              <Text style={styles.cellScore}>{item.d1}</Text>
              <Text style={styles.cellScore}>{item.p1}</Text>
              <Text style={styles.cellScore}>{item.p2}</Text>
              <Text style={styles.cellScore}>{item.p3}</Text>
              <Text style={styles.cellScore}>{item.o1}</Text>
              <Text style={styles.cellScore}>{item.o2}</Text>
              <Text style={styles.cellScore}>{item.a}</Text>
            </View>
          ))
        ) : (
          <Text style={{ textAlign: "center", padding: 10 }}> No data available </Text>
        )}
      </View>
      <View style={styles.container}>
        <Text style={styles.text}>{"\u2022"} S - Self</Text>
        <Text style={styles.text}>{"\u2022"} M - Manager</Text>
        <Text style={styles.text}>{"\u2022"} D - Direct Report</Text>
        <Text style={styles.text}>{"\u2022"} P - Peer</Text>
        <Text style={styles.text}>{"\u2022"} O - Other</Text>
        <Text style={styles.text}>{"\u2022"} A - Average</Text>
      </View>
      {/* <Footer /> */}
    </View>
  );
};

export default QuadrantFlowItemThird360;
